
import React, {
  useEffect,
  useState,
} from "react";

import {
  FiCalendar,
  FiRefreshCw,
} from "react-icons/fi";

import {
  getDailySafeSummary,
} from "./CashAndDisbursementsService";

const DailySafeSummary = () => {
  // =========================================================
  // Selected Date
  // =========================================================

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  // =========================================================
  // Summary
  // =========================================================

 const [summary, setSummary] = useState({
  netCashInSafe: 0,
  netInstaPayInSafe: 0,
  netVodafoneCashInSafe: 0,
  netAmountInSafe: 0,
  totalExpensesAmount: 0,
});

  const [loading, setLoading] = useState(false);

  // =========================================================
  // Format Number
  // =========================================================

  const formatNumber = (value) => {
    return Number(value || 0).toLocaleString(
      "ar-EG"
    );
  };

  // =========================================================
  // Load Summary
  // =========================================================

 const loadSummary = async () => {
  if (!selectedDate) {
    return;
  }

  try {
    setLoading(true);

    const response = await getDailySafeSummary(selectedDate);

    const result = response?.data || response;

    setSummary({
      // كاش
      netCashInSafe: Number(
        result?.netCashInSafe || 0
      ),

      // InstaPay
      netInstaPayInSafe: Number(
        result?.netInstaPayInSafe || 0
      ),

      // Vodafone Cash
      netVodafoneCashInSafe: Number(
        result?.netVodafoneCashInSafe || 0
      ),

      // إجمالي الخزنة
      netAmountInSafe: Number(
        result?.netAmountInSafe || 0
      ),

      // إجمالي المنصرف
      totalExpensesAmount: Number(
        result?.totalExpensesAmount || 0
      ),
    });

  } catch (error) {
    console.error(
      "GET DAILY SAFE SUMMARY ERROR:",
      error
    );

    setSummary({
      netCashInSafe: 0,
      netInstaPayInSafe: 0,
      netVodafoneCashInSafe: 0,
      netAmountInSafe: 0,
      totalExpensesAmount: 0,
    });

  } finally {
    setLoading(false);
  }
};
  // =========================================================
  // Load when Date Changes
  // =========================================================

  useEffect(() => {
    loadSummary();
  }, [selectedDate]);

  // =========================================================
  // Render
  // =========================================================

  return (
    <div className="daily-safe-summary-wrapper">

      {/* =====================================================
          Filter
      ====================================================== */}

      <div className="daily-safe-summary-filter">

        <div className="daily-safe-summary-filter-title">

          <FiCalendar size={16} />

          <span>
            ملخص الخزنة اليومية
          </span>

        </div>

        <div className="daily-safe-summary-filter-controls">

          <label>
            التاريخ
          </label>

          <input
            type="date"
            value={selectedDate}
            onChange={(event) =>
              setSelectedDate(
                event.target.value
              )
            }
          />

          <button
            type="button"
            onClick={loadSummary}
            disabled={loading}
            className="daily-safe-summary-refresh"
          >
            <FiRefreshCw
              size={15}
              className={
                loading
                  ? "cash-spin"
                  : ""
              }
            />

            تحديث
          </button>

        </div>

      </div>

      {/* =====================================================
          Summary Values
      ====================================================== */}

      <div className="daily-safe-summary">

        {/* ===================================================
            Net Amount In Safe
        ==================================================== */}


          <div className="daily-safe-summary-item">
            <span>كاش</span>

            <strong>
              {loading
                ? "..."
                : formatNumber(summary.netCashInSafe)}
            </strong>
          </div>

          <div className="daily-safe-summary-item">
            <span>InstaPay</span>

            <strong>
              {loading
                ? "..."
                : formatNumber(summary.netInstaPayInSafe)}
            </strong>
          </div>

          <div className="daily-safe-summary-item">
            <span>Vodafone Cash</span>

            <strong>
              {loading
                ? "..."
                : formatNumber(summary.netVodafoneCashInSafe)}
            </strong>
          </div>

          <div className="daily-safe-summary-item">
            <span>إجمالي الخزنة</span>

            <strong>
              {loading
                ? "..."
                : formatNumber(summary.netAmountInSafe)}
            </strong>
          </div>


      </div>

    </div>
  );
};

export default DailySafeSummary;
